import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';

import ListItem from './ListItem';

const ListBody = ({ data, fields, bodyClass }) => (
  <tbody className={`tvt-report-list__body ${bodyClass}`}>
    {data.map(item => (
      <ListItem key={uuid()} fields={fields} data={item} />
    ))}
  </tbody>
);

ListBody.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired,
  bodyClass: PropTypes.string
};

ListBody.defaultProps = {
  bodyClass: ''
};

export default ListBody;
